import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export function getTableDiv(value){

  var div = 
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var resolveRange = function(range){
    range = range.split('-')
    range =
      _.map(range,function(r){
        if(r * 1 == r){
          return r * 1
        }
      })
    var length = range[1] - range[0]
    for (var i = 1; i < length; i++) {
      range.push(range[0]+i)
    }
    return range
  }

  if(column.value === undefined){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var years = column.value.split(',')

  years =
    _.map(years,function(y){
      if(_.includes(y,'-')){
        var range = resolveRange(y)
        return range
      } else if (y * 1 == y){
        return y * 1
      }
    })

  years = _.flatten(years)
  years = _.sortBy(years)
  
  if(filter[0] == "<"){
    var maxYear = filter.slice(1) * 1 - 1
    var range = "1940-"+maxYear
    range = resolveRange(range)
  } else if(filter[0] == ">"){
    var minYear = filter.slice(1) * 1 + 1
    var range = minYear+"-2017"
    range = resolveRange(range)
  } else if(_.includes(filter,'-')){
    var range = resolveRange(filter)
  } else {
    var range = [filter * 1]
  }

  range = _.flatten(range)
  range = _.sortBy(range)

  if(_.isEmpty(_.intersection(range,years))){
    return false
  } else {
    return true
  }

}

export function getFormField(o,p,field){

  var format = function(value){
    return value
  }

  var parse = function(value){
    value = value.trim()
    return value
  }

  var isValid = function(value){
    if(value === ""){
      return true
    }
    var valid = true
    _.each(value.split(','),function(item){
      if(!item.match(/^((\d\d\d\d-\d\d\d\d)|(\d\d\d\d))$/)){
        valid = false
      }
    })
    return valid
  }

  var validate = function(value){
    if(
      (value || field.optional) &&
      isValid(value)
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var labelDiv = 
    button(field.id,null,true)
    .css({
      display: 'block',
      paddingRight: '20px',
    })

  var disabled = field.edit ? false : true

  var inputDiv =
    input(disabled)
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}


// WEBPACK FOOTER //
// ./src/client/view/admin/type/years/years.js